import api from './apiService';

export interface Facility {
  id: number;
  name: string;
  slug: string;
  icon?: string;
  color?: string;
  description?: string;
}

class FacilityService {
  async getFacilities(): Promise<Facility[]> {
    try {
      const res = await api.get('/facilities');
      if (Array.isArray(res.data)) return res.data;
      if (res.data?.data && Array.isArray(res.data.data)) return res.data.data;
      return [];
    } catch (err) {
      console.error('Error fetching facilities', err);
      return [];
    }
  }
}

export const facilityService = new FacilityService();
